import client from './axiosInstance';

export const fetchPoliciesFilterList = async () => {
  return await client.get(`/policies/base/policies`);
};
